/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-27T13:49:57-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-17T15:14:12-07:00
*/



import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { StyleSheet, css } from 'aphrodite/no-important';
import { dimensions, spacing, type, borders, textColor } from '../../../style';
import Button from '../../blocks/Button';
import Panel from '../../common/Panel';

const style = StyleSheet.create({
  card: {
    padding: '46px 12px',
    ...spacing.PADDING_MD,
    backgroundColor: '#fff',
    borderBottomWidth: '1px',
    borderRadius: '3px',
    margin: '10px',
    textAlign: 'center',
    flexGrow: 1,

    [dimensions.SCREEN_MIN_MD]: {
      flex: '0 1 280px',
      paddingLeft: '16px',
      borderRightWidth: '1px',
      borderBottomWidth: '0'
    }
  },
  title: {
    margin: '0',
    ...type.LG,
    ...type.NORMAL,
    textAlign: 'center',
    // fontWeight: '300',
  },

  price: {
    ...type.title.LG,
    fontWeight: '300',
    display: 'block',
    ...spacing.MARGIN_BOTTOM_XS
  },

  length: {
    ...spacing.MARGIN_BOTTOM_SM
  },

  currency: {
    display: 'inline-block',
    ...type.LG,
    ...type.NORMAL,
    ...textColor.NORMAL,
    ...spacing.PADDING_RIGHT_XS
  }

});

const frequency = (upgradeDays) => {
  if (upgradeDays > 30) {
    let months = upgradeDays/30
    return `every ${months} months`
  }
  else {

    return `monthly`
  }
}

const renderMonthlyCharge = (price, upgradeDays) => {
  return <div className={css(style.length)}><strong>${price}</strong> will be charged {frequency(upgradeDays)}</div>
}

class PlanCard extends Component {

  render() {
    return (
      <div className={css(style.card)}>
          <h3 className={css(style.title)}>{this.props.days} DAYS</h3>
          <div className={css(style.details)}>
            <span className={css(style.price)}>
              <span className={css(style.currency)}>{String.fromCharCode(this.props.currencyUTF)}</span>{this.props.monthlyPrice} per month
            </span>
            { renderMonthlyCharge(this.props.price, this.props.upgradeDays)}
          </div>
          <Link to={`/billing/${this.props.packageId}`}><Button fit variant="primary">Upgrade Now</Button></Link>
          <div className={css(style.rightBorder)} />
      </div>
    );
  }
}

PlanCard.propTypes = {
  days: PropTypes.number.isRequired,
  monthlyPrice: PropTypes.any.isRequired,
  packageId: PropTypes.string.isRequired
}



export default PlanCard;



// WEBPACK FOOTER //
// ./src/components/pages/Billing/PlanCard.jsx